import { getRailsClient } from "../client";

import { TournamentContentShared } from "./types/tournamentTypes";
import { Lesson } from "./types/lessonTypes";
import { Assessment, Question } from "./types/quizTypes";
import { Experiment, UsedHint } from "./types/experimentTypes";

export interface TournamentLessonResponse extends TournamentContentShared {
  sessionStartedAt?: string;
  usedHints: UsedHint[];
  steps: number[];
  lesson: {
    lesson: Lesson;
    assessment: Assessment;
    resourcesNumber: number;
    isConsumed: boolean;
  };
  assessmentProps: {
    assessment: Assessment;
    question: Question | null;
    questionsData?: Question[];
  };
}

export interface TournamentExperimentResponse extends TournamentContentShared {
  experiment: {
    experiment: Experiment;
    steps: number[];
  };
}

export const fetchTournamentLesson = async (
  tournamentContentId: string
): Promise<TournamentLessonResponse> => {
  const API = `/api/internal_api/v2/tournament_contents/${tournamentContentId}/show_lesson_content`;
  try {
    const { data } = await getRailsClient().get<TournamentLessonResponse>(API);
    return data;
  } catch (error) {
    console.error(`Error fetching tournament content with ID ${tournamentContentId}:`, error);
    throw Error;
  }
};

export const fetchTournamentExperiment = async (
  tournamentContentId: string
): Promise<TournamentExperimentResponse> => {
  const API = `/api/internal_api/v2/tournament_contents/${tournamentContentId}/show_experiment_content`;
  try {
    const { data } = await getRailsClient().get<TournamentExperimentResponse>(API);
    return data;
  } catch (error) {
    console.error(`Error fetching tournament content with ID ${tournamentContentId}:`, error);
    throw Error;
  }
};
